import getBatchValues from 'src/js/modules/element-settings/helpers/get-batch-values';
import generateModifiedEventTraits from 'src/js/modules/element-settings/helpers/generate-modified-event-traits';
import attributes from '../constants/attributes';
import getIsBooleanAttributeWithModifiedTraits from './get-is-boolean-attribute-with-modified-traits';
import traitValueNormalizers from './trait-value-normalizers';

const getTraitName = (attribute) => {
  switch (attribute) {
    case attributes.SURFACE: {
      return 'ColorScheme';
    }

    case attributes.HORIZONTAL_ALIGNMENT: {
      return 'HorizontalContentAlignment';
    }

    case attributes.VERTICAL_ALIGNMENT: {
      return 'VerticalContentAlignment';
    }

    case attributes.BORDER_TOP_LEFT_RADIUS: {
      return 'TopLeftCorner';
    }

    case attributes.BORDER_TOP_RIGHT_RADIUS: {
      return 'TopRightCorner';
    }

    case attributes.BORDER_BOTTOM_LEFT_RADIUS: {
      return 'BottomLeftCorner';
    }

    case attributes.BORDER_BOTTOM_RIGHT_RADIUS: {
      return 'BottomRightCorner';
    }

    case attributes.PADDING_TOP: {
      return 'TopSpacing';
    }

    case attributes.PADDING_BOTTOM: {
      return 'BottomSpacing';
    }

    case attributes.PADDING_LEFT: {
      return 'LeftSpacing';
    }

    case attributes.PADDING_RIGHT: {
      return 'RightSpacing';
    }

    case attributes.COLUMN_GAP: {
      return 'HorizontalGap';
    }

    case attributes.ROW_GAP: {
      return 'VerticalGap';
    }

    case attributes.LAYOUT: {
      return 'Amount';
    }

    case attributes.HORIZONTAL_ALIGN: {
      return 'Alignments';
    }

    case attributes.VERTICAL_ALIGN: {
      return 'VerticalAlignments';
    }

    default: {
      return attribute;
    }
  }
};

const getModifiedTraits = ({ prefix, modifiedAttributes, state, initialState }) => {
  const elementIds = Object.keys(initialState);

  const modifiedTraits = modifiedAttributes.reduce((accTraits, attribute) => {
    const [currentValue] = getBatchValues(state, {
      elementIds,
      attributes: [attribute],
    }).flat();
    const [initialValue] = getBatchValues(initialState, {
      elementIds,
      attributes: [attribute],
    }).flat();

    if (
      typeof currentValue === 'boolean' &&
      !getIsBooleanAttributeWithModifiedTraits({ attribute })
    ) {
      return accTraits;
    }

    const currentTraitName = getTraitName(attribute);
    const normalize = traitValueNormalizers[attribute] || ((value) => value);
    const currentTraits = generateModifiedEventTraits(
      prefix,
      currentTraitName,
      normalize(initialValue),
      normalize(currentValue)
    );

    return {
      ...accTraits,
      ...currentTraits,
    };
  }, {});

  return modifiedTraits;
};

export default getModifiedTraits;
